<template>
  <SwipeDialog
    class="visit-create-dialog"
    :title="title"
    :context-menu-actions="contextMenuActions"
    :show-context-menu="showContextMenu"
    style="height: 100%; overflow: scroll"
    @closeFn="handleBack"
    @contextMenuFn="contextMenuFn"
  >
    <template #right>
      <van-button
        type="info"
        size="small"
        color="#aa341b"
        :loading="saveLoading"
        :disabled="!canSave"
        style="font-size: 16px; height: 32px; padding: 0 16px; border-radius: 32px;"
        @click="save"
      >
        {{ $t('btn_save') }}
      </van-button>
    </template>
    <van-tabs
      v-model="tabIndex"
      class="visit-tabs"
      color="#aa341b"
      style="position: sticky; top: 0px; z-index: 9"
    >
      <van-tab
        v-for="item in tabs"
        :key="item"
        :title="$t(item)"
      />
    </van-tabs>
    <div class="visit-form-content">
      <!-- 拜访信息 -->
      <div v-show="tabs[tabIndex] === 'visit_info'">
        <div class="visit-info-card">
          <div
            v-for="(item, index) in baseVisitFields"
            :key="index"
            class="visit-field-row"
            :class="{
              'companion-field-row': item?.field === 'companions',
              'space-field-row': item?.type === 'space',
            }"
          >
            <SchemaField
              v-if="item?.field"
              v-model="formState[item.field]"
              :schema="item"
              :editable="editable"
            />
            <SchemaField v-else-if="item?.type === 'space'" :schema="item" />
            <div v-if="item?.field === 'companions' && editable" class="companion-helper">
              {{ $t('hcp_visit_companion_helper') }}
            </div>
          </div>

        </div>

        <div
          v-if="productVisitField"
          class="visit-info-card visit-product-card"
        >
          <div class="product-field-row">
            <SchemaField
              v-model="formState[productVisitField.field]"
              :schema="productVisitField"
              :editable="editable"
            />
          </div>

          <!-- 关键信息 Multi-select Popup -->
          <div v-if="availableKeyPromotions.length > 0 && editable" class="key-message-editor">
            <van-field
              readonly
              clickable
              required
              name="keyPromotion"
              :label="$t('key_message')"
              right-icon="arrow-down"
              class="field-box-style"
              @click="showKeyPromotionPopup = true"
            >
              <template #input>
                <div v-if="keyPromotionTags.length > 0" class="tag-container">
                  <div v-for="tag in keyPromotionTags" :key="tag.id" class="custom-tag">
                    <span v-if="tag.productName" class="custom-tag-product">
                      {{ tag.productName }}
                    </span>
                    <span class="custom-tag-text">{{ tag.text }}</span>
                  </div>
                </div>
                <span v-else class="placeholder-text">{{ $t('please_placeholder') }}</span>
              </template>
            </van-field>
            <van-popup
              v-model="showKeyPromotionPopup"
              position="bottom"
              round
              class="key-promotion-popup"
              get-container="body"
            >
              <div class="key-promotion-toolbar">
                <span class="key-promotion-cancel" @click="showKeyPromotionPopup = false">{{ $t('btn_cancel') }}</span>
                <span class="key-promotion-title">{{ $t('select_key_message') }}</span>
                <span class="key-promotion-confirm" @click="showKeyPromotionPopup = false">{{ $t('btn_sure') }}</span>
              </div>
              <!-- Popup Content with Checkbox Group -->
              <div class="key-promotion-groups">
                <van-checkbox-group v-model="formState.key_promotion_ids">
                  <section
                    v-for="group in groupedKeyPromotions"
                    :key="group.productId"
                    class="key-promotion-group"
                  >
                    <div class="key-promotion-group-heading">
                      <span>{{ group.productName }}</span>
                      <span class="key-promotion-group-count">{{ group.items.length }}</span>
                    </div>
                    <van-cell-group>
                      <van-cell
                        v-for="item in group.items"
                        :key="`${group.productId}-${item.kvp_key_id}`"
                        clickable
                        class="key-promotion-option"
                        :title="item.kvp_key_name"
                        @click="toggleKeyPromotion(item.kvp_key_id)"
                      >
                        <template #right-icon>
                          <van-checkbox ref="checkboxes_kp" :name="item.kvp_key_id" checked-color="#aa341b" @click.stop />
                        </template>
                      </van-cell>
                    </van-cell-group>
                  </section>
                </van-checkbox-group>
              </div>
            </van-popup>
          </div>
          <!-- Readonly View for Key Promotion (when !editable) -->
          <div v-if="availableKeyPromotions.length > 0 && !editable" class="key-message-readonly">
            <van-field
              readonly
              name="keyPromotion"
              :value="keyPromotionDisplayText"
              :label="$t('key_message')"
              input-align="right"
              style="padding: 0;"
            />
          </div>

        </div>

        <section
          v-for="strategy in selectedStrategyProducts"
          :key="strategy.productId"
          :class="[
            'strategy-map-card',
            {'strategy-map-card--azilect': strategy.productId === 'Azilect_000001'},
          ]"
        >
          <div class="strategy-map-title">
            <span class="strategy-map-title-accent"></span>
            <span>{{ strategy.title }}</span>
          </div>
          <component
            :is="strategy.component"
            class="strategy-map-content"
            :physician-id="formState.physician_id"
            :product-id="strategy.productId"
            :show-actions="false"
          />
        </section>
      </div>
      <!-- 餐费 -->
      <div v-show="tabs[tabIndex] === 'expense_info'">
        <!-- 费用信息 start -->
        <div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div
              style="
                font-size: 16px;
                text-align: left;
                font-weight: bold;
                padding: 20px 10px 10px 10px;
              "
            >
              {{ $t('expense_info_title') }}
            </div>
            <van-button
              v-if="showAddExpense && editable"
              type="danger"
              round
              size="small"
              plain
              style="margin: 15px 0 10px 0"
              @click="deleteDiner"
            >
              {{ $t('delete_expense') }}
            </van-button>
          </div>

          <div
            v-if="!showAddExpense"
            style="
              display: flex;
              justify-content: space-between;
              margin-top: 10px;
              padding: 0 10px;
            "
          >
            <div
              style="
                font-size: 14px;
                text-align: left;
                color: #7f7f81;
                padding-left: 10px;
              "
              v-html="$t('expense_desc')"
            >
            </div>
            <van-button
              v-if="editable"
              type="info"
              round
              size="small"
              plain
              @click="showAddExpense = true"
            >
              {{ $t('add_expense') }}
            </van-button>
          </div>
          <AddExpense
            v-show="showAddExpense"
            ref="addExpense"
            :show-add-expense="showAddExpense"
            :show-cost-proportion="showCostProportion"
            :cost-proportion="costProportion"
            :def-doctors="
              formState.physician_mr_call__physician_mr_call_diner_physicians
            "
            :def-colleagues="
              formState.physician_mr_call__physician_mr_call_diner_users
            "
            :budget-res="callBudget"
            :call-products="defCall_products"
            :def-diner-amount="defDinerAmount"
            :def-editable="editable"
            @draft-change="handleChildDraftChange"
          />
        </div>
        <!-- 费用信息 end -->
      </div>
      <!-- 拜访反馈 -->
      <div v-if="enableAI" v-show="tabs[tabIndex] === 'visit_feedback'">
        <!-- <div
          v-if="formState.call_product_id?.includes('Brintellix_000001')"
          style="padding: 12px"
        >
          <div style="font-size: 16px; text-align: left; font-weight: bold">
            Brintellix 策略地图
          </div>

          <BrintellixSuggestion
            :physician-id="formState.physician_id"
            :product-id="'Brintellix_000001'"
            :show-actions="false"
            @nbaLoaded="nbaLoaded"
          />
        </div> -->
        <!-- <div
          v-if="formState.call_product_id?.includes('Azilect_000001')"
          style="padding: 12px"
        >
          <div style="font-size: 16px; text-align: left; font-weight: bold">
            Azilect 策略地图
          </div>
          <AzilectSuggestion :physician-id="formState.physician_id" :product-id="'Azilect_000001'" :show-actions="false" />
        </div> -->
        <!-- <div style="background: #fff; padding: 10px 0">
          <div style="padding: 10px">
            <div
              style="
                font-size: 16px;
                text-align: left;
                font-weight: bold;
                padding-bottom: 20px;
              "
            >
              反馈内容
            </div>
            <div class="question">此次互动目标是否达成？</div>
            <div class="space">
              <van-button
                v-for="(item, index) in ['尚未', '达成']"
                :key="index"
                :disabled="!editable"
                type="info"
                round
                size="small"
                color="#aa341b"
                :plain="formState.feedback_call_object_meet !== item"
                @click="formState.feedback_call_object_meet = item"
              >
                {{ ['×', '√'][index] }} {{ item }}
              </van-button>
            </div>
          </div>
          <div style="padding: 10px">
            <div class="question">专家是否可能发生分型或认可阶段转变？</div>
            <div class="space">
              <van-button
                v-for="(item, index) in ['没有', '有可能']"
                :key="index"
                :disabled="!editable"
                type="info"
                round
                size="small"
                color="#aa341b"
                :plain="formState.feedback_segment_ladder_changed !== item"
                @click="formState.feedback_segment_ladder_changed = item"
                >{{ ['×', '√'][index] }} {{ item }}</van-button
              >
            </div>
          </div>
          <div v-if="false">
            <div class="question" style="padding: 10px 10px 0">
              请填写您收集到的医生观念信息：
            </div>
            <div style="margin: 0 -6px">
              <SchemaField
                v-model="formState.call_description"
                :schema="{type: 'textarea'}"
              />
              <SpeechToText
                @translateResult="formState.call_description += $event"
              />
            </div>
          </div>
        </div> -->
        <KeyFeedbackEditList
          ref="keyFeedbackEditList"
          :physician_id="formState.physician_id"
          :source_msl_call_id="editId"
          :visit-owner-user-id="formState.call_user_id"
          :visit-owner-user-name="visitOwnerUserName"
          :show-feedback-author="showFeedbackAuthor"
          @draft-change="handleChildDraftChange"
        />
      </div>
      <div style="height: 40px"></div>
    </div>
    <AISummaryConfirmDialog
      v-if="enableAI"
      v-model="showAiSummaryDialog"
      :title="$t('ai_visit_summary_title')"
      :request-fn="streamCallSummary"
      :request-data="aiSummaryRequestData"
      :confirm-loading="aiSummarySaving"
      :confirm-text="$t('btn_confirm')"
      @confirm="handleAiSummaryConfirm"
    />
  </SwipeDialog>
</template>

<script>
import Vue from 'vue';
import BrintellixSuggestion from '@/views/hcp/components/NBA/Brintellix.vue';
import AzilectSuggestion from '@/views/hcp/components/NBA/Azilect.vue';
import {Dialog, Tab, Tabs, Picker, Popup, Icon, Button, Toast, Field, Checkbox, CheckboxGroup, Cell, CellGroup} from 'vant';
import SwipeDialog from '@/views/layout/swipeDialog';
import SchemaField from '@/components/form/SchemaField.vue';
import AISummaryConfirmDialog from '@/components/AISummaryConfirmDialog.vue';
import AddExpense from './components/addExpense.vue';
import {
  getUserPhysicianProduct,
  fetchOnePhysicianMrCall,
  getGetMRCallBudget,
  createMrCall,
  deleteMrCall,
  createCRMCall,
  updateCRMCall,
  deleteCRMCall,
  getPhysicianMrCallCompanions,
  createPhysicianMrCallCompanion,
  deletePhysicianMrCallCompanion,
  getPhysiciansDetail,
} from '@/api/Physicians';
import { getPhysicianTasks, executeTask } from '@/api/nba';
import { streamCallSummary } from '@/api/ai';
import {validateFields} from './util';
import {physicianListOptionsMixins} from '@/mixins/physicianListOptions';
import kvpKeysMixin from '@/mixins/kvpKey';
import {getLocalStorage, isGBA, debounce, isEnableAI} from '@/utils';
import moment from 'moment';
import {
  deletePhysicianMrCallKeyFeedback,
  fetchPhysicianMrCallKeyFeedbacks,
  fetchVUsers,
} from '../../api/kol';
// import SpeechToText from '@/components/SpeechToText.vue';
import KeyFeedbackEditList from '@/views/hcp/components/KeyFeedbackEditList.vue';
import {
  createVisitDraftId,
  findVisitDraftBySource,
  getVisitDraft,
  removeVisitDraft,
  removeVisitDraftBySource,
  upsertVisitDraft,
} from '@/utils/visitDraft';

Vue.use(Popup);
Vue.use(Picker);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Cell);
Vue.use(CellGroup);

export default {
  components: {
    SwipeDialog,
    SchemaField,
    AISummaryConfirmDialog,
    BrintellixSuggestion,
    // SpeechToText,
    AddExpense,
    AzilectSuggestion,
    KeyFeedbackEditList,
  },
  mixins: [kvpKeysMixin('call_channel'), kvpKeysMixin('mr_call_purpose'), kvpKeysMixin('meeting_key_promotion')],
  data() {
    return {
      productList: [],
      saveLoading: false,
      tabIndex: 0,
      formState: {
        call_product_id: [],
        key_promotion_ids: [],
        call_time: new Date(),
        call_period: '',
        feedback_segment_ladder_changed: '',
        feedback_call_object_meet: '',
        co_call_description: '',
        call_description: '',
        physician_id: '',
        call_purpose: '',
        call_channel: '',
        crm_call_id: '',
        crm_status: '',
        companions: [], // New field for array of companions
      },
      currentCompanions: [],
      old_companions: [], // For tracking changes
      feedbackNba: null,
      test: '',
      physicianOptions: [],
      physician: null,
      showAddExpense: false,
      showCostProportion: false,
      costProportion: [],
      callBudget: 0,
      defDinerAmount: 0,
      defCall_products: [],
      initialSnapshot: null,
      initialExpenseSnapshot: null,
      showKeyPromotionPopup: false,
      currentDraftId: '',
      selectedPhysicianInfo: null,
      draftHydrating: false,
      draftReady: false,
      persistDraftDebounced: null,
      showAiSummaryDialog: false,
      aiSummarySaving: false,
      aiSummaryRequestData: {},
      pendingSavedCallId: '',
      feedbackHasUnsavedChanges: false,
      persistedCallUserId: '',
      visitOwnershipLoaded: false,
    };
  },
  computed: {
    availableKeyPromotions() {
      const selectedProductIds = this.formState.call_product_id || [];
      if (this.meeting_key_promotion && this.meeting_key_promotion.length > 0 && selectedProductIds.length > 0) {
        return this.meeting_key_promotion.filter(kvp => {
          if (!kvp.parent_kvp_key_id) return false;
          const parentIds = kvp.parent_kvp_key_id.split(',');
          return selectedProductIds.some(id => parentIds.includes(id));
        });
      }
      return [];
    },
    groupedKeyPromotions() {
      const selectedProductIds = new Set(
        (this.formState.call_product_id || []).map(id => String(id)),
      );

      return (this.productList || [])
        .filter(product => selectedProductIds.has(String(product.product_id)))
        .map(product => ({
          productId: product.product_id,
          productName: product.product_name,
          items: this.availableKeyPromotions.filter((promotion) =>
            String(promotion.parent_kvp_key_id || '')
              .split(',')
              .map(id => id.trim())
              .includes(String(product.product_id)),
          ),
        }))
        .filter(group => group.items.length > 0);
    },
    keyPromotionDisplayText() {
      return this.keyPromotionTags
        .map(tag => tag.productName ? `${tag.productName} - ${tag.text}` : tag.text)
        .join('，');
    },
    keyPromotionTags() {
      if (!this.formState.key_promotion_ids || this.formState.key_promotion_ids.length === 0) return [];
      const selectedProductIds = new Set(
        (this.formState.call_product_id || []).map(id => String(id)),
      );
      const showProductName = selectedProductIds.size > 1;
      const tags = [];
      this.formState.key_promotion_ids.forEach(id => {
        const item = this.meeting_key_promotion ? this.meeting_key_promotion.find(k => k.kvp_key_id === id) : null;
        if (!item) return;

        const parentProductIds = new Set(
          String(item.parent_kvp_key_id || '')
            .split(',')
            .map(productId => productId.trim())
            .filter(Boolean),
        );
        const productName = showProductName
          ? (this.productList || [])
            .filter(product =>
              selectedProductIds.has(String(product.product_id)) &&
              parentProductIds.has(String(product.product_id)),
            )
            .map(product => product.product_name)
            .join('/')
          : '';

        tags.push({
          id: item.kvp_key_id,
          productName,
          text: item.kvp_key_name,
        });
      });
      return tags;
    },
    is_co_call() {
      if (this.isGBA) {
        return this.isJointVisit ? 1 : 0;
      }
      return this.isCoVisit ? 1 : 0;
    },
    name() {
      if (this.isGBA) return this.$t('visit');
      return this.isCoVisit ? this.$t('co_visit') : this.$t('visit');
    },
    title() {
      if (this.isParticipantOnly) {
        return this.$t('hcp_visit_view_title');
      }
      const action = this.editId ? this.$t('edit_btn') : this.$t('create');
      return action + ' ' + this.name;
    },
    isCoVisit() {
      return this.$route.query.isCoVisit === '1';
    },
    isGBA() {
      return isGBA();
    },
    isJointVisit() {
      return Array.isArray(this.formState.companions) && this.formState.companions.length > 0;
    },
    visitTypeText() {
      return this.is_co_call ? '协访' : '拜访';
    },
    visitOwnerUserName() {
      if (this.formState.call_user_name) return this.formState.call_user_name;
      const currentUserId = String(getLocalStorage('user_id') || '');
      if (!this.editId || this.persistedCallUserId === currentUserId) {
        return getLocalStorage('user_name') || '';
      }
      return '';
    },
    showFeedbackAuthor() {
      return Number(this.formState.is_co_call) === 1 || this.is_co_call === 1;
    },
    isParticipantOnly() {
      if (!this.editId) return false;
      // Existing visits stay read-only until their owner has been loaded. This
      // closes the loading window where an empty call_user_id could previously
      // be treated as the current user's visit.
      if (!this.visitOwnershipLoaded || !this.persistedCallUserId) return true;
      return this.persistedCallUserId !== String(getLocalStorage('user_id') || '');
    },
    aiLanguage() {
      const language = typeof window !== 'undefined' ? window.localStorage.getItem('language') : '';
      return /^en/i.test(language) ? 'en-US' : 'zh-CN';
    },
    enableAI() {
      return isEnableAI();
    },
    draftMode() {
      return this.isGBA ? 'gba' : 'hcp';
    },
    tabs() {
      if (!this.enableAI) {
        return this.isGBA ? ['visit_info'] : ['visit_info', 'expense_info'];
      }
      if (this.isGBA) {
        return ['visit_info', 'visit_feedback'];
      }
      return ['visit_info', 'expense_info', 'visit_feedback'];
    },
    editId() {
      return this.$route.query?.id;
    },
    hasDraft() {
      return Boolean(this.currentDraftId);
    },
    isDraftOnly() {
      return this.hasDraft && !this.editId;
    },
    fields() {
      return this.isGBA || !this.isCoVisit ? this.visitFields : this.coVisitFields;
    },
    baseVisitFields() {
      return this.fields.filter(item => item?.field !== 'call_product_id');
    },
    productVisitField() {
      return this.fields.find(item => item?.field === 'call_product_id');
    },
    selectedStrategyProducts() {
      const selectedProductIds = this.formState.call_product_id || [];
      return [
        {
          productId: 'Azilect_000001',
          title: this.$t('azilect_strategy_map'),
          component: 'AzilectSuggestion',
        },
        {
          productId: 'Brintellix_000001',
          title: this.$t('brintellix_strategy_map'),
          component: 'BrintellixSuggestion',
        },
      ].filter(item => selectedProductIds.includes(item.productId));
    },
    showContextMenu() {
      return !this.isParticipantOnly && Boolean(this.editId || this.hasDraft);
    },
    contextMenuActions() {
      const actions = [];

      if (this.hasDraft) {
        actions.push({text: this.$t('hcp_visit_delete_draft_action')});
      }

      if (this.editId) {
        actions.push({text: '删除拜访'});
      }

      return actions;
    },
    editable() {
      if (this.isParticipantOnly) {
        return false;
      }
      if (this.isSubmittedCrmCall) {
        return false;
      }
      const roleId = getLocalStorage('role_id');
      if (roleId && String(roleId) !== '2') {
        return true;
      }
      return this.formState?.crm_status !== 'Submitted_vod';
    },
    shouldUseDraft() {
      return !this.editId || this.editable;
    },
    canSave() {
      if (this.isParticipantOnly) {
        return Boolean(this.editId) && this.feedbackHasUnsavedChanges;
      }
      return this.editable || (Boolean(this.editId) && this.feedbackHasUnsavedChanges);
    },
    normalizedCrmStatus() {
      return String(this.formState?.crm_status || '').trim();
    },
    isSubmittedCrmCall() {
      return Boolean(this.formState?.crm_call_id) && this.normalizedCrmStatus === 'Submitted_vod';
    },
    isCreatingVisit() {
      return !this.editId && !this.formState.physician_mr_call_id;
    },
    minDate() {
      // 计算7天前的日期
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      return sevenDaysAgo;
    },
    timePeriods() {
      return [
        { text: this.$t('morning'), id: '上午' },
        { text: this.$t('afternoon'), id: '下午' },
        { text: this.$t('full_day'), id: '全天' }
      ];
    },
    coVisitFields() {
      return [
        {
          field: 'physician_id',
          label: this.$t('visit_customer'),
          placeholder: this.$t('hcp_visit_customer_placeholder'),
          required: true,
          type: 'doctorSelect',
          rightIcon: 'contact',
          options: this.physicianOptions,
          onGet: (data) => {
            this.updateSelectedPhysicianInfo(data[0]);
          },
        },
        {
          field: 'call_time',
          type: 'date',
          label: this.$t('visit_date'),
          placeholder: this.$t('hcp_visit_date_placeholder'),
          required: true,
          minDate: this.isCreatingVisit ? this.minDate : undefined,
        },
        {
          field: 'call_period',
          label: this.$t('visit_time'),
          placeholder: this.$t('hcp_visit_time_placeholder'),
          type: 'select',
          options: this.timePeriods,
          required: true,
        },
        {
          field: 'call_channel',
          label: this.$t('visit_type'),
          placeholder: this.$t('hcp_visit_type_placeholder'),
          type: 'select',
          options: this.call_channel?.map((item) => item.kvp_key_name),
          required: true,
        },
        {
          field: 'companions',
          label: this.$t('hcp_visit_companion_field'),
          type: 'userSelect',
          props: {
            fn: this.fetchCompanionOptions,
            groupByDepartment: true,
            panelHeight: '88vh',
            title: this.$t('hcp_visit_companion_selector_title'),
            selectedFontSize: '14px',
            softSelectedItems: true,
            placeholder: this.$t('hcp_visit_companion_placeholder'),
            fieldIcon: 'friends-o',
          },
        },
        {
          type: 'space',
        },
        {
          field: 'call_purpose',
          label: this.$t('visit_goal'),
          placeholder: this.$t('hcp_visit_goal_placeholder'),
          type: 'select',
          options: this.mr_call_purpose.map((item) => item.kvp_key_name),
          required: true,
        },
        // {
        //   field: 'co_call_description',
        //   label: '协访说明',
        //   type: 'textarea',
        //   placeholder: '协访目的或协访结果说明',
        // },
      ];
    },
    visitFields() {
      const fields = [
        {
          field: 'physician_id',
          label: this.$t('visit_customer'),
          placeholder: this.$t('hcp_visit_customer_placeholder'),
          required: true,
          type: 'doctorSelect',
          rightIcon: 'contact',
          options: this.physicianOptions,
          onChange: (data) => {
            this.fetchProductList(data);
          },
          onGet: (data) => {
            console.log('cnm--->', data, this.$refs.addExpense.doctors);
            this.updateSelectedPhysicianInfo(data[0]);
            if (this.$refs.addExpense.doctors.length === 0) {
              this.$refs.addExpense.doctors = data.map((item) => {
                return {
                  physician_id: item.physician_id,
                  physician_name: item.physician_name,
                  department_name: item.department_name,
                  institution_id: item.institution_id,
                  institution_name: item.institution_name,
                  professional_title: item.professional_title,
                };
              });
            }
          },
        },
        {
          field: 'call_time',
          type: 'date',
          label: this.$t('visit_date'),
          placeholder: this.$t('hcp_visit_date_placeholder'),
          required: true,
          minDate: this.isCreatingVisit ? this.minDate : undefined,
        },
        {
          field: 'call_period',
          label: this.$t('visit_time'),
          placeholder: this.$t('hcp_visit_time_placeholder'),
          type: 'select',
          options: this.timePeriods,
          required: true,
        },
        {
          field: 'call_channel',
          label: this.$t('visit_type'),
          placeholder: this.$t('hcp_visit_type_placeholder'),
          type: 'select',
          options: this.call_channel.map((item) => item.kvp_key_name),
          required: true,
        },
        ...(this.isGBA ? [{
          field: 'companions',
          label: this.$t('hcp_visit_companion_field'),
          type: 'userSelect',
          props: {
            fn: this.fetchCompanionOptions,
            groupByDepartment: true,
            panelHeight: '88vh',
            title: this.$t('hcp_visit_companion_selector_title'),
            selectedFontSize: '14px',
            softSelectedItems: true,
            placeholder: this.$t('hcp_visit_companion_placeholder'),
            fieldIcon: 'friends-o',
          },
        }] : []),
        {
          type: 'space',
        },
        {
          field: 'call_purpose',
          label: this.$t('visit_goal'),
          placeholder: this.$t('hcp_visit_goal_placeholder'),
          type: 'select',
          options: this.mr_call_purpose.map((item) => item.kvp_key_name),
          required: true,
        },
      ];

      if (this.productList && this.productList.length > 0) {
        fields.push({
          field: 'call_product_id',
          label: this.$t('involved_product'),
          type: 'checkbox',
          props: {
            chipStyle: true,
          },
          options: this.productList.map((item) => ({
            text: item.product_name,
            value: item.product_id,
          })),
        });
      }

      return fields;
    },
  },
  watch: {
    'formState.call_product_id': function (newVal, oldVal) {
      const selectedProductIds = Array.isArray(newVal) ? newVal : [];
      const res = this.productList.filter((item) =>
        selectedProductIds.includes(item.product_id),
      );
      this.costProportion = res;
      this.defCall_products = this.formState.call_products;
      if (selectedProductIds.length > 1) {
        this.showCostProportion = true;
      } else {
        this.showCostProportion = false;
      }
      this.pruneKeyPromotions(selectedProductIds);
      this.scheduleDraftSave();
    },
    'formState.physician_id': function (newVal) {
      console.log('physician_id', newVal);
    },
    formState: {
      handler() {
        this.scheduleDraftSave();
      },
      deep: true,
    },
    showAddExpense() {
      this.scheduleDraftSave();
    },
    tabIndex() {
      this.scheduleDraftSave();
    },
  },
  created() {
    this.persistDraftDebounced = debounce(() => {
      this.persistDraft();
    }, 500);
  },
  async mounted() {
    const targetPhysicianId = this.$route.query?.physician_id;
    if (targetPhysicianId) {
      this.formState.physician_id = targetPhysicianId;
      await this.fetchProductList(targetPhysicianId);
      await this.fetchSelectedPhysicianInfo(targetPhysicianId);
      if (this.editId) {
        await this.fetchOnePhysicianMrCall();
      }
    } else if (this.editId) {
      await this.fetchOnePhysicianMrCall();
    }

    const nbaId = this.$route.query?.nba_id;
    if (nbaId) {
      this.formState.nba_execution_id = nbaId;
    }

    // Read default parameters from query
    const { visit_date, visit_time, visit_type, visit_goal } = this.$route.query;
    if (visit_date) {
      this.formState.call_time = new Date(visit_date);
    }
    if (visit_time) {
      this.formState.call_period = visit_time;
    }
    if (visit_type) {
      this.formState.call_channel = visit_type;
    }
    if (visit_goal) {
      this.formState.call_purpose = visit_goal;
    }

    await this.restoreDraftIfNeeded();
    await this.$nextTick();
    this.recordSnapshot();
    this.syncFeedbackDirtyState();
    this.getCallBudget();
    this.draftReady = true;
  },
  beforeDestroy() {
    if (!this.draftReady || !this.shouldUseDraft) {
      return;
    }
    this.persistDraft({ensureDraftId: false});
  },
  methods: {
    streamCallSummary,
    fetchCompanionOptions(searchKey, pagination) {
      const currentUserId = String(getLocalStorage('user_id') || '');
      return fetchVUsers(searchKey, pagination).then((items) =>
        (items || []).filter(item => String(item?.user_id || '') !== currentUserId),
      );
    },
    recordSnapshot() {
      this.initialSnapshot = this.getFormSnapshot();
      this.initialExpenseSnapshot = this.getExpenseSnapshot();
    },
    getFormSnapshot() {
      return JSON.stringify(JSON.parse(JSON.stringify(this.formState)));
    },
    getExpenseSnapshot() {
      return JSON.stringify(this.getNormalizedExpenseSnapshot());
    },
    normalizeIdList(list = [], fields = []) {
      return (list || [])
        .map(item => {
          const normalized = {};
          fields.forEach(field => {
            normalized[field] = item?.[field] || '';
          });
          return normalized;
        })
        .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));
    },
    getNormalizedExpenseSnapshot() {
      const expenseState = this.$refs.addExpense?.getDraftState?.() || {};
      const isDiner = Boolean(this.showAddExpense);

      if (!isDiner) {
        return {is_diner: false};
      }

      return {
        is_diner: true,
        diner_amount: Number(expenseState.diner_amount || 0),
        diner_physicians: this.normalizeIdList(expenseState.doctors, [
          'physician_id',
          'physician_name',
          'institution_id',
          'institution_name',
        ]),
        diner_users: this.normalizeIdList(expenseState.colleagues, [
          'user_id',
          'user_name',
        ]),
        call_products: this.normalizeIdList(expenseState.costProportionSubmit, [
          'product_id',
          'product_name',
          'cost_proportion',
        ]).map(item => ({
          ...item,
          cost_proportion: Number(item.cost_proportion || 0),
        })),
      };
    },
    getFeedbackRef() {
      return this.$refs.keyFeedbackEditList;
    },
    syncFeedbackDirtyState() {
      this.feedbackHasUnsavedChanges = Boolean(this.getFeedbackRef()?.hasUnsavedChanges?.());
    },
    handleChildDraftChange() {
      this.syncFeedbackDirtyState();
      this.scheduleDraftSave();
    },
    scheduleDraftSave() {
      if (
        !this.shouldUseDraft ||
        this.draftHydrating ||
        !this.draftReady ||
        !this.persistDraftDebounced
      ) {
        return;
      }
      this.persistDraftDebounced();
    },
    hasFeedbackDraftChanges() {
      return Boolean(this.getFeedbackRef()?.hasUnsavedChanges?.());
    },
    hasExpenseDraftChanges() {
      return this.initialExpenseSnapshot !== this.getExpenseSnapshot();
    },
    hasFormDraftChanges() {
      return this.initialSnapshot !== this.getFormSnapshot();
    },
    shouldKeepDraft() {
      if (!this.shouldUseDraft) {
        return false;
      }
      return this.hasFormDraftChanges() || this.hasExpenseDraftChanges() || this.hasFeedbackDraftChanges();
    },
    buildDraftPayload() {
      return {
        draftId: this.currentDraftId,
        userId: getLocalStorage('user_id'),
        mode: this.draftMode,
        sourceCallId: this.editId || this.formState.physician_mr_call_id || '',
        isCoVisit: Boolean(this.is_co_call),
        showAddExpense: this.showAddExpense,
        tabIndex: this.tabIndex,
        physician: this.selectedPhysicianInfo,
        formState: JSON.parse(JSON.stringify(this.formState)),
        expenseState: this.$refs.addExpense?.getDraftState?.() || {},
        feedbackState: this.getFeedbackRef()?.getDraftState?.() || {},
      };
    },
    persistDraft({force = false, ensureDraftId = true} = {}) {
      if (this.draftHydrating || !this.draftReady) {
        return null;
      }

      if (!force && !this.shouldKeepDraft()) {
        return null;
      }

      if (!this.currentDraftId) {
        if (!ensureDraftId) {
          return null;
        }
        this.currentDraftId = createVisitDraftId();
      }

      const draft = upsertVisitDraft(this.buildDraftPayload());
      this.$root.$emit('updateVisitDraftCount');
      return draft;
    },
    async restoreDraftIfNeeded() {
      if (!this.shouldUseDraft) {
        return;
      }

      const routeDraftId = this.$route.query?.draftId;
      const draft = routeDraftId
        ? getVisitDraft(routeDraftId)
        : findVisitDraftBySource({
          userId: getLocalStorage('user_id'),
          mode: this.draftMode,
          sourceCallId: this.editId,
        });

      if (!draft) {
        return;
      }

      this.currentDraftId = draft.draftId;
      this.draftHydrating = true;

      const restoredFormState = JSON.parse(JSON.stringify(draft.formState || {}));
      if (restoredFormState.call_time) {
        restoredFormState.call_time = new Date(restoredFormState.call_time);
      }
      Object.assign(this.formState, restoredFormState);
      if (restoredFormState.physician_id) {
        await this.fetchProductList(restoredFormState.physician_id, false);
        if (!draft.physician?.physician_name) {
          await this.fetchSelectedPhysicianInfo(restoredFormState.physician_id);
        }
      }
      this.showAddExpense = Boolean(draft.showAddExpense);
      this.tabIndex = Number.isInteger(draft.tabIndex) ? draft.tabIndex : 0;
      this.selectedPhysicianInfo = draft.physician || this.selectedPhysicianInfo;

      await this.$nextTick();
      this.$refs.addExpense?.applyDraftState?.(draft.expenseState || {});
      this.getFeedbackRef()?.applyDraftState?.(draft.feedbackState || {});
      this.draftHydrating = false;
      this.syncFeedbackDirtyState();
    },
    async fetchSelectedPhysicianInfo(physicianId) {
      if (!physicianId) {
        return;
      }
      try {
        const res = await getPhysiciansDetail(physicianId);
        const item = res?.value?.[0];
        if (item) {
          this.updateSelectedPhysicianInfo(item);
        }
      } catch (e) {
        console.error(e);
      }
    },
    updateSelectedPhysicianInfo(item) {
      if (!item) {
        return;
      }
      this.selectedPhysicianInfo = {
        physician_id: item.physician_id,
        physician_name: item.physician_name,
        department_name: item.department_name,
        institution_id: item.institution_id,
        institution_name: item.institution_name,
        professional_title: item.professional_title,
      };
    },
    clearDraftState(sourceCallId = '') {
      if (this.currentDraftId) {
        removeVisitDraft(this.currentDraftId);
        this.currentDraftId = '';
      }
      removeVisitDraftBySource({
        userId: getLocalStorage('user_id'),
        mode: this.draftMode,
        sourceCallId,
      });
      this.$root.$emit('updateVisitDraftCount');
    },
    async deleteRelatedFeedbacks(sourceCallId) {
      if (!sourceCallId) {
        return;
      }

      const pageSize = 100;
      let skip = 0;
      let feedbackIds = [];
      let hasMore = true;

      while (hasMore) {
        const res = await fetchPhysicianMrCallKeyFeedbacks(
          {physician_mr_call_id: sourceCallId},
          skip,
          pageSize,
        );
        const items = Array.isArray(res?.value) ? res.value : [];
        feedbackIds = feedbackIds.concat(
          items
            .map(item => item.physician_mr_call_key_feedback_id)
            .filter(Boolean),
        );
        hasMore = items.length === pageSize;
        skip += items.length;
      }

      if (!feedbackIds.length) {
        return;
      }

      await Promise.all(
        feedbackIds.map(id => deletePhysicianMrCallKeyFeedback(id)),
      );
    },
    handleBack() {
      let isChanged = false;
      const currentSnapshot = this.getFormSnapshot();
      if (this.initialSnapshot && currentSnapshot !== this.initialSnapshot) {
        isChanged = true;
      }

      if (!isChanged && this.hasExpenseDraftChanges()) {
        isChanged = true;
      }

      if (!isChanged && this.$refs.keyFeedbackEditList && this.$refs.keyFeedbackEditList.hasUnsavedChanges) {
        if (this.$refs.keyFeedbackEditList.hasUnsavedChanges()) {
          isChanged = true;
        }
      }

      if (isChanged) {
        if (this.shouldUseDraft) {
          this.persistDraft({force: true});
          Dialog.confirm({
            title: this.$t('hcp_visit_draft_dialog_title'),
            message: this.$t('hcp_visit_draft_auto_saved_confirm_back'),
          })
            .then(() => {
              this.$router.go(-1);
            })
            .catch(() => {
              // Cancel navigation
            });
        } else {
          Dialog.confirm({
            title: this.$t('hcp_visit_draft_dialog_title'),
            message: this.$t('confirm_back'),
          })
            .then(() => {
              this.$router.go(-1);
            })
            .catch(() => {
              // Cancel navigation
            });
        }
      } else {
        this.$router.go(-1);
      }
    },
    async fetchProductList(physician_id, setDefaultValue = true) {
      const productId = this.$route.query?.product_id;

      const params = {
        user_id: getLocalStorage('user_id'),
        physician_id,
      };
      const res = await getUserPhysicianProduct(params);
      this.productList = res.value;

      if (setDefaultValue && productId) {
        res.value.forEach((item) => {
          if (item.product_id === productId) {
            this.formState['call_product_id'] = [item.product_id];
          }
        });
      }

      return res;
    },
    handleChange(field, value) {
      console.log(field, value, 'field value');
      this.formState[field] = value;
    },
    async fetchOnePhysicianMrCall() {
      const {physician, ...res} = await fetchOnePhysicianMrCall(this.editId);
      this.persistedCallUserId = String(res.call_user_id || '');
      this.visitOwnershipLoaded = true;
      Object.assign(this.formState, res);
      if (physician) {
        await this.fetchProductList(physician?.physician_id, false);
        this.updateSelectedPhysicianInfo(physician);
      }
      this.physician = physician;
      this.formState.call_product_id = JSON.parse(res.call_products).map(
        (item) => item.product_id,
      );

      if (res.key_promotion_kvp) {
        this.formState.key_promotion_ids = res.key_promotion_kvp.split(',');
      } else {
        this.formState.key_promotion_ids = [];
      }

      // Fetch companions
      const companionRes = await getPhysicianMrCallCompanions(this.editId);
      if (companionRes.value && companionRes.value.length > 0) {
        this.currentCompanions = companionRes.value;
        this.formState.companions = companionRes.value.map(item => ({
          user_id: item.user_id,
          user_name: item.user_name,
          physician_mr_call_companion_id: item.physician_mr_call_companion_id
        }));
        this.old_companions = [...this.formState.companions];
      } else {
        this.formState.companions = [];
        this.old_companions = [];
      }

      // this.formState.call_products = res.call_products;
      this.defDinerAmount = res.diner_amount;

      this.showAddExpense = Boolean(this.formState.is_diner);

      this.showCostProportion = JSON.parse(res.call_products).length > 1;
      // this.costProportion = JSON.parse(res.call_products);
      console.log('JSON.parse(res.call_products)', this.costProportion);
      // let callDate = new Date(this.formState.call_time);
      // let today = new Date();
      // today.setHours(0, 0, 0, 0);
      // if (callDate > today) {
      //   console.log('future');
      // }
    },
    async getCallBudget() {
      const budgetRes = await getGetMRCallBudget({
        call_user_id: getLocalStorage('user_id'),
        call_time: moment(this.formState.call_time).format('YYYY-MM-DD HH:mm:ss'),
      });
      if (budgetRes.isSuccess) {
        if (budgetRes.data === -1) {
          this.callBudget = '不允许报销';
        } else if (budgetRes.data === -2) {
          this.callBudget = '无限额';
        } else {
          this.callBudget = budgetRes.data;
        }
      }
    },
    getSelectedPhysicianInfo() {
      if (this.physician && this.physician.physician_id === this.formState.physician_id) {
        return this.physician;
      }

      const physician =
        (this.physicianOptions || []).find(
          item => item.physician_id === this.formState.physician_id
        ) ||
        (this.$refs.addExpense?.doctors || []).find(
          item => item.physician_id === this.formState.physician_id
        );

      return physician || {};
    },
    getFeedbackSummaryItems() {
      const feedbackList = this.$refs.keyFeedbackEditList?.insightFormList || [];

      return feedbackList
        .map((item, index) => {
          const content = [
            item.feedback_content,
            item.feedback_transcript,
            item.feedback_summary,
          ]
            .filter(Boolean)
            .join('\n')
            .trim();

          if (!content) return null;

          return {
            index: index + 1,
            topic_name: item.topic_name || '',
            question: item.question || '',
            feedback_content: item.feedback_content || '',
            feedback_transcript: item.feedback_transcript || '',
            feedback_summary: item.feedback_summary || '',
            feedback_labels: Array.isArray(item.tags) ? item.tags.join(',') : '',
          };
        })
        .filter(Boolean);
    },
    shouldGenerateAiSummary() {
      return this.enableAI && this.getFeedbackSummaryItems().length > 0;
    },
    buildAiSummaryRequestData(sourceCallId) {
      const physician = this.getSelectedPhysicianInfo();
      const selectedProducts = (this.productList || [])
        .filter(item => (this.formState.call_product_id || []).includes(item.product_id))
        .map(item => ({
          product_id: item.product_id,
          product_name: item.product_name,
        }));

      const payload = {
        instruction: /^en/i.test(this.aiLanguage)
          ? 'Based on the visit information and visit feedback below, generate an English call summary within 50 words. Output summary text only. Do not include any title, numbering, quotation marks, or explanation.'
          : '请基于以下拜访基本信息和拜访反馈，生成一个50字以内的中文拜访总结。只输出总结正文，不要包含标题、序号、引号或解释。',
        visit_basic_info: {
          physician_mr_call_id: sourceCallId,
          visit_type: this.visitTypeText,
          physician_id: this.formState.physician_id,
          physician_name: physician.physician_name || '',
          institution_name: physician.institution_name || '',
          department_name: physician.department_name || '',
          professional_title: physician.professional_title || '',
          call_time: moment(this.formState.call_time).format('YYYY-MM-DD'),
          call_period: this.formState.call_period || '',
          call_channel: this.formState.call_channel || '',
          call_purpose: this.formState.call_purpose || '',
          key_promotion: this.keyPromotionDisplayText || '',
          call_products: selectedProducts,
        },
        visit_feedback: this.getFeedbackSummaryItems(),
      };

      return {
        content: JSON.stringify(payload, null, 2),
        language: this.aiLanguage,
      };
    },
    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    },
    getSaveErrorDetail(error) {
      if (typeof error === 'string') {
        return error;
      }

      const response = error?.response;
      const responseData = response?.data;
      const responseError = responseData?.error;
      const status = response?.status;
      let detail = [
        typeof responseData === 'string' ? responseData : '',
        responseData?.message,
        responseData?.Message,
        typeof responseError === 'string'
          ? responseError
          : responseError?.message?.value || responseError?.message,
        responseData?.error_description,
        responseData?.title,
      ].find(item => typeof item === 'string' && item.trim());

      if (!detail && status === 401) {
        detail = this.$t('save_auth_error');
      } else if (!detail && status === 403) {
        detail = this.$t('save_permission_error');
      } else if (!detail && status === 413) {
        detail = this.$t('save_payload_too_large');
      } else if (!detail && status >= 500) {
        detail = this.$t('save_server_error');
      } else if (!detail && (error?.code === 'ECONNABORTED' || /timeout/i.test(error?.message || ''))) {
        detail = this.$t('save_timeout_error');
      } else if (!detail && error?.message === 'Network Error') {
        detail = this.$t('save_network_error');
      } else if (!detail && error?.message) {
        detail = error.message;
      }

      detail = detail || this.$t('save_unknown_error');
      detail = String(detail).replace(/\s+/g, ' ').trim();
      if (detail.length > 180) {
        detail = `${detail.slice(0, 180)}...`;
      }

      return status ? `HTTP ${status}: ${detail}` : detail;
    },
    showSaveError(error, stage = 'save') {
      console.error(`[VisitCreate] ${stage} failed`, error);
      const title = this.escapeHtml(this.$t('save_fail'));
      const detail = this.escapeHtml(this.getSaveErrorDetail(error));

      this.$toast.fail({
        type: 'html',
        message: `<div class="save-error-title">${title}</div><div class="save-error-detail">${detail}</div>`,
        duration: 6000,
        className: 'save-fail-toast',
        icon: 'cross',
      });
    },
    finishSave() {
      const sourceCallId = this.pendingSavedCallId || this.formState.physician_mr_call_id || this.editId || '';
      this.showAiSummaryDialog = false;
      this.aiSummarySaving = false;
      this.pendingSavedCallId = '';
      this.aiSummaryRequestData = {};
      this.syncFeedbackDirtyState();
      this.recordSnapshot();
      this.clearDraftState(sourceCallId);
      Toast(this.editId ? this.$t('save_success') : this.$t('create_success'));
      this.saveLoading = false;
      if (isGBA()) {
        this.$router.replace('/gba/visit-list');
      } else {
        this.$router.replace('/hcp/visit-list');
      }
    },
    async handleAiSummaryConfirm(summary) {
      if (!summary || !this.pendingSavedCallId) {
        this.showAiSummaryDialog = false;
        this.finishSave();
        return;
      }

      this.aiSummarySaving = true;
      try {
        const ownsVisit = await this.verifyVisitOwnership();
        if (!ownsVisit) {
          this.showAiSummaryDialog = false;
          this.finishSave();
          return;
        }
        await createMrCall({
          physician_mr_call_id: this.pendingSavedCallId,
          call_summary: summary,
        });
        this.formState.call_summary = summary;
        this.showAiSummaryDialog = false;
        this.finishSave();
      } catch (error) {
        this.showSaveError(error, 'AI summary save');
      } finally {
        this.aiSummarySaving = false;
      }
    },
    async saveFeedbackOnly() {
      if (!this.editId) {
        return;
      }

      this.saveLoading = true;
      try {
        if (this.$refs.keyFeedbackEditList) {
          await this.$refs.keyFeedbackEditList.save(
            this.editId,
            this.visitTypeText,
            this.formState.physician_id,
            this.costProportion
          );
        }
        this.finishSave();
      } catch (err) {
        this.showSaveError(err, 'feedback save');
      } finally {
        this.saveLoading = false;
      }
    },
    async verifyVisitOwnership() {
      if (!this.editId) {
        return true;
      }

      const currentUserId = String(getLocalStorage('user_id') || '');
      if (!currentUserId) {
        return false;
      }

      // Always verify against the persisted record immediately before a main
      // visit mutation. UI state and local drafts must never grant ownership.
      const latestVisit = await fetchOnePhysicianMrCall(this.editId);
      const latestOwnerUserId = String(latestVisit?.call_user_id || '');
      this.persistedCallUserId = latestOwnerUserId;
      this.visitOwnershipLoaded = true;
      this.formState.call_user_id = latestVisit?.call_user_id || '';
      this.formState.call_user_name = latestVisit?.call_user_name || '';

      return Boolean(latestOwnerUserId) && latestOwnerUserId === currentUserId;
    },
    async save() {
      if (this.editId && this.isParticipantOnly) {
        await this.saveFeedbackOnly();
        return;
      }

      if (this.editId) {
        try {
          const ownsVisit = await this.verifyVisitOwnership();
          if (!ownsVisit) {
            await this.saveFeedbackOnly();
            return;
          }
        } catch (error) {
          // Fail closed: if ownership cannot be verified, do not send any
          // request that can update the visit or its expense information.
          this.showSaveError(error, 'visit ownership verification');
          return;
        }
      }

      if (this.isSubmittedCrmCall && this.editId) {
        await this.saveFeedbackOnly();
        return;
      }

      if (!this.canSave) {
        return;
      }

      if (!this.editable && this.editId) {
        await this.saveFeedbackOnly();
        return;
      }

      const {physician, ...formState} = this.formState;

      // 新建拜访时，拜访日期不能早于7天前；编辑保存不限制历史日期。
      if (this.isCreatingVisit) {
        const callDate = new Date(formState.call_time);
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        sevenDaysAgo.setHours(0, 0, 0, 0);
        callDate.setHours(0, 0, 0, 0);

        if (callDate < sevenDaysAgo) {
          Toast(this.$t('visit_date_limit'));
          this.saveLoading = false;
          return;
        }
      }

      if (!validateFields(this.fields, formState)) return;

      if (this.availableKeyPromotions.length > 0 && (!this.formState.key_promotion_ids || this.formState.key_promotion_ids.length === 0)) {
        Toast(this.$t('fill_key_message'));
        return;
      }

      this.saveLoading = true;
      let params = {
        ...formState,
        is_co_call: this.is_co_call,
      };

      // Ownership fields are assigned only when creating a visit. For updates,
      // preserve the values loaded from the persisted record and never replace
      // another representative's identity with the current user.
      if (!this.editId) {
        Object.assign(params, {
          call_user_id: getLocalStorage('user_id'),
          call_user_name: getLocalStorage('user_name'),
          call_territory_id: getLocalStorage('territory_id'),
          call_role_id: getLocalStorage('role_id'),
        });
      }

      // Key Promotion Handling
      if (this.formState.key_promotion_ids && this.formState.key_promotion_ids.length > 0) {
        params.key_promotion_kvp = this.formState.key_promotion_ids.join(',');

        const selectedNames = [];
        this.formState.key_promotion_ids.forEach(id => {
          const item = (this.meeting_key_promotion || []).find(k => k.kvp_key_id === id);
          if (item) selectedNames.push(item.kvp_key_name);
        });
        params.key_promotion = selectedNames.join(',');
      } else {
        params.key_promotion_kvp = null;
        params.key_promotion = null;
      }
      delete params.key_promotion_ids;

      // CRM Status
      // if (!this.formState.crm_status) {
      //   if (this.formState.call_time)
      // }
      // Removed single user assignment logic
      delete params.companions; // Do not send companions array in main body
      delete params.co_call_coach_user;

      if (this.feedbackNba) {
        params.feedback_physician_ladder_nba_id =
          this.feedbackNba.physician_ladder_nba_id;
        params.feedback_physician_ladder_nba_details = JSON.stringify(
          this.feedbackNba,
        );
        console.log('has nba', params);
      }
      // 校验是否填写餐费 start
      const expense = this.$refs.addExpense;
      if (this.showAddExpense) {
        // 判断日期是否是昨天或以前的（仅对于新拜访创建）
        if (!this.formState.physician_mr_call_id) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const callDate = new Date(this.formState.call_time);
          if (callDate < today) {
            Toast(this.$t('expense_date_limit'));
            this.saveLoading = false;
            return;
          }
        }

        // 判断是否至少选了一个产品
        if (formState.call_product_id.length === 0) {
          Toast(this.$t('expense_product_limit'));
          this.saveLoading = false;
          return;
        }

        // 判断餐费预算是否超过300标准及YTD余额
        const totalPeople = expense.doctors.length + expense.colleagues.length;
        if (totalPeople && Number(expense.diner_amount) / totalPeople > 300) {
          Toast(this.$t('expense_limit_300'));
          this.saveLoading = false;
          return;
        }
        if (Number(expense.diner_amount) > this.callBudget) {
          Toast(this.$t('expense_limit_ytd'));
          this.saveLoading = false;
          return;
        }
        // 判断products是否为100%
        if (this.showCostProportion) {
          const allNumber = expense.costProportionSubmit.reduce(
            (acc, curr) => Number(acc) + Number(curr.cost_proportion),
            0,
          );
          console.log('allNumber---->', allNumber);
          if (allNumber !== 100) {
            Toast(this.$t('expense_product_proportion'));
            this.saveLoading = false;
            return;
          }
        } else {
          // 仅一个产品，cost_proportion设为100
          expense.costProportionSubmit.forEach(item => {
            item.cost_proportion = 100;
          });
        }
        let data = {};
        data.diner_amount = Number(expense.diner_amount);
        data.diner_physicians = expense.doctors;
        data.diner_users = expense.colleagues;
        data.call_products = expense.costProportionSubmit;
        data.is_diner = this.showAddExpense;
        console.log('expense--->', data);
        params = {...params, ...data};
      } else {
        let data = {};
        data.is_diner = this.showAddExpense;
        data.call_products = expense.costProportionSubmit.map((item) => {
          return {
            product_id: item.product_id,
            product_name: item.product_name,
          };
        });
        params = {...params, ...data};
      }
      // 校验是否填写餐费 end
      params.is_save_diner = !this.formState.physician_mr_call_id || this.hasExpenseDraftChanges();
      try {
        // 保存CRM call
        // 是否已经有crm_call_id
        var crmRes;

        if (this.formState.physician_mr_call_id) {
          // Update
          crmRes = await updateCRMCall(params);
          console.log('crm call update result', crmRes);
        } else {
          // Create
          crmRes = await createCRMCall(params);
          console.log('crm call create result', crmRes);
        }

        if (crmRes && crmRes.isSuccess) {
          const source_msl_call_id = this.formState.physician_mr_call_id || crmRes.data;
          this.formState.physician_mr_call_id = source_msl_call_id;

          const newCompanions = (this.formState.companions || []).filter(Boolean);

          // Companions define whether this is a joint visit, so they are maintained
          // for every GBA visit instead of only for the legacy co-visit route.
          await Promise.all(
            this.old_companions
              .filter(
                oldItem => !newCompanions.find(newItem => newItem.user_id === oldItem.user_id),
              )
              .map(item => deletePhysicianMrCallCompanion(item.physician_mr_call_companion_id)),
          );

          await Promise.all(
            newCompanions
              .filter(
                newItem => !this.old_companions.find(oldItem => oldItem.user_id === newItem.user_id),
              )
              .map(item => createPhysicianMrCallCompanion({
                physician_mr_call_id: source_msl_call_id,
                user_id: item.user_id,
                user_name: item.user_name,
              })),
          );

          // 保存洞见

          if (this.$refs.keyFeedbackEditList) {
            await this.$refs.keyFeedbackEditList.save(
              source_msl_call_id,
              this.visitTypeText,
              this.formState.physician_id,
              this.costProportion
            );
          }

          // 如果有对应的拜访任务，标记为已执行
          try {
            const taskRes = await getPhysicianTasks(this.formState.physician_id, getLocalStorage('user_id'), null, false, 1, 100, getLocalStorage('role_id'));
            if (taskRes && taskRes.data && Array.isArray(taskRes.data)) {
              for (const task of taskRes.data) {
                if (task.event_type === 'visit' || task.event_type === 'call') {
                  await executeTask(
                    'accept',
                    task.campaign_event_id,
                    task.physician_id,
                    getLocalStorage('user_id'),
                    getLocalStorage('user_name') || '',
                    getLocalStorage('territory_id') || '',
                    getLocalStorage('role_id') || ''
                  );
                  this.$root.$emit('updateTaskCount');
                }
              }
            }
          } catch (e) {
            console.error('执行拜访任务失败:', e);
          }

          if (this.shouldGenerateAiSummary()) {
            this.syncFeedbackDirtyState();
            this.recordSnapshot();
            this.clearDraftState(source_msl_call_id);
            this.pendingSavedCallId = source_msl_call_id;
            this.aiSummaryRequestData = this.buildAiSummaryRequestData(source_msl_call_id);
            this.saveLoading = false;
            this.showAiSummaryDialog = true;
          } else {
            this.finishSave();
          }
        } else {
          this.showSaveError(crmRes?.message || this.$t('save_unknown_error'), 'CRM save');
          this.saveLoading = false;
        }
      } catch (err) {
        this.showSaveError(err, 'CRM save');
        this.saveLoading = false;
      }
    },
    handleAddSuggestion(item) {
      this.tabIndex = this.tabs.indexOf('visit_feedback');
      this.$refs.keyFeedbackEditList.addInsightForm({
        insight_question: item,
      });
    },
    contextMenuFn(action) {
      if (action === this.$t('hcp_visit_delete_draft_action')) {
        Dialog.confirm({
          title: this.$t('hcp_visit_draft_dialog_title'),
          message: this.$t('hcp_visit_delete_draft_confirm'),
          beforeClose: this.beforeCloseDraft,
        });
      } else if (action === '删除拜访') {
        Dialog.confirm({
          message: '是否删除这条记录',
          beforeClose: this.beforeCloseVisit,
        });
      }
    },
    beforeCloseDraft(action, done) {
      if (action === 'confirm') {
        this.clearDraftState(this.editId || this.formState.physician_mr_call_id);
        this.$toast.success(this.$t('hcp_visit_draft_deleted'));
        setTimeout(() => {
          this.$router.go(-1);
        }, 100);
        done();
      } else if (action === 'cancel') {
        done();
      }
    },
    async beforeCloseVisit(action, done) {
      if (action === 'confirm') {
        this.saveLoading = true;
        if (this.editId) {
          try {
            const ownsVisit = await this.verifyVisitOwnership();
            if (!ownsVisit) {
              this.$toast.fail(this.$t('save_permission_error'));
              this.saveLoading = false;
              done();
              return;
            }
          } catch (error) {
            this.showSaveError(error, 'visit ownership verification');
            this.saveLoading = false;
            done();
            return;
          }

          this.deleteRelatedFeedbacks(this.editId)
            .then(() => deleteCRMCall({
              physician_mr_call_id: this.editId,
            }))
            .then((res) => {
              if (res.isSuccess) {
                this.clearDraftState(this.editId);
                this.$toast.success('删除成功');
                setTimeout(() => {
                  this.$router.go(-1);
                }, 100);
                this.saveLoading = false;
                done();
              } else {
                this.$toast.fail(
                  {
                    message: '删除失败' + (res.message ? '\n' + res.message : ''),
                    duration: 4000,
                    className: 'fail-toast',
                    icon: 'cross',
                  }
                );
                this.saveLoading = false;
                done();
              }
            })
            .catch((err) => {
              console.log(err);
              this.$toast.fail('删除失败');
              this.saveLoading = false;
              done();
            });

          // deleteMrCall(this.editId).then((res) => {
          //   if (res?.value === this.editId) {
          //     this.$toast.success("删除成功");
          //     setTimeout(() => {
          //       this.$router.go(-1);
          //     }, 100);
          //   } else {
          //     this.$toast.fail("删除失败，请重试");
          //   }
          //   this.saveLoading = false;
          //   done();
          // }).catch((err) => {
          //   console.log(err);
          //   this.$toast.fail("删除失败，请重试");
          //   this.saveLoading = false;
          //   done();
          // });
        } else {
          this.$toast.fail('删除失败');
          this.saveLoading = false;
          done();
        }
      } else if (action === 'cancel') {
        done();
      }
    },
    nbaLoaded(nba) {
      this.feedbackNba = nba;
    },
    toggleKeyPromotion(id) {
      if (!this.editable) return;
      // Toggle manually if needed, but CheckboxGroup usually handles v-model update via click on checkbox.
      // The van-cell @click handles the row click.
      // We need to find if 'id' is in array, and add/remove.
      const index = this.formState.key_promotion_ids.indexOf(id);
      if (index !== -1) {
        this.formState.key_promotion_ids.splice(index, 1);
      } else {
        this.formState.key_promotion_ids.push(id);
      }
    },
    pruneKeyPromotions(selectedProductIds = []) {
      const currentPromotionIds = this.formState.key_promotion_ids || [];
      if (!currentPromotionIds.length) return;

      if (!selectedProductIds.length) {
        this.formState.key_promotion_ids = [];
        return;
      }

      if (!Array.isArray(this.meeting_key_promotion) || !this.meeting_key_promotion.length) {
        return;
      }

      const selectedProductIdSet = new Set(
        selectedProductIds.map(id => String(id)),
      );
      const validPromotionIds = new Set(
        this.meeting_key_promotion
          .filter((promotion) =>
            String(promotion.parent_kvp_key_id || '')
              .split(',')
              .map(id => id.trim())
              .some(id => selectedProductIdSet.has(id)),
          )
          .map(promotion => String(promotion.kvp_key_id)),
      );
      const nextPromotionIds = currentPromotionIds.filter(id =>
        validPromotionIds.has(String(id)),
      );

      if (nextPromotionIds.length !== currentPromotionIds.length) {
        this.formState.key_promotion_ids = nextPromotionIds;
      }
    },
    deleteDiner() {
      this.showAddExpense = false;
      this.formState.is_diner = false;
    },
  },
};
</script>

<style scoped lang="scss">
.visit-create-dialog {
  background: #f6f7f9;
}

.visit-create-dialog ::v-deep .header {
  background: #fff;
  box-shadow: 0 1px 0 rgba(33, 37, 41, 0.08);
}

.visit-create-dialog ::v-deep .header .h-title {
  color: #151719;
  font-size: 17px;
  font-weight: 600;
}

.visit-tabs {
  background: #fff;
}

.visit-tabs ::v-deep .van-tabs__wrap {
  height: 46px;
  border-bottom: 1px solid #f0f1f3;
}

.visit-tabs ::v-deep .van-tab {
  color: #666;
  font-size: 15px;
}

.visit-tabs ::v-deep .van-tab--active {
  color: #aa341b;
  font-weight: 600;
}

.visit-form-content {
  padding: 12px;
}

.visit-info-card {
  padding: 14px 14px 4px;
  border: 1px solid rgba(31, 35, 40, 0.04);
  border-radius: 18px;
  background: #fff;
  box-shadow: 0 4px 18px rgba(31, 35, 40, 0.05);
}

.visit-product-card,
.strategy-map-card {
  margin-top: 12px;
}

.visit-product-card {
  padding-bottom: 14px;
}

.visit-info-card ::v-deep .field > .van-cell {
  padding: 0 0 12px;
  background: transparent;
}

.visit-info-card ::v-deep .field > .van-cell::after {
  display: none;
}

.visit-info-card ::v-deep .van-field__label {
  margin-bottom: 5px;
  color: #202326;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
}

.visit-info-card ::v-deep .van-cell--required::before {
  top: 0;
  left: 0;
  line-height: 22px;
}

.visit-info-card ::v-deep .van-cell--required .van-field__label {
  padding-left: 11px;
}

.visit-info-card ::v-deep .doctorSelect .valueBorder .van-cell__value,
.visit-info-card ::v-deep .date .valueBorder .van-cell__value,
.visit-info-card ::v-deep .select .valueBorder .van-cell__value,
.visit-info-card ::v-deep .userSelect .valueBorder .van-cell__value,
.visit-info-card ::v-deep .singleUserSelect .valueBorder .van-cell__value {
  min-height: 34px;
  margin: 0 !important;
  padding: 5px 11px !important;
  border: 1px solid #e1e3e6 !important;
  border-radius: 8px !important;
  display: flex;
  align-items: center;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.visit-info-card ::v-deep .doctorSelect .valueBorder .van-cell__value:focus-within,
.visit-info-card ::v-deep .date .valueBorder .van-cell__value:focus-within,
.visit-info-card ::v-deep .select .valueBorder .van-cell__value:focus-within,
.visit-info-card ::v-deep .userSelect .valueBorder .van-cell__value:focus-within,
.visit-info-card ::v-deep .singleUserSelect .valueBorder .van-cell__value:focus-within {
  border-color: rgba(170, 52, 27, 0.55) !important;
  box-shadow: 0 0 0 2px rgba(170, 52, 27, 0.08);
}

.visit-info-card ::v-deep .van-field__control,
.visit-info-card ::v-deep .van-field__body {
  color: #25282b;
  font-size: 14px;
}

.visit-info-card ::v-deep .user-select-placeholder {
  font-size: 14px;
}

.visit-info-card ::v-deep .van-field__body {
  width: 100%;
}

.visit-info-card ::v-deep .van-field__control::placeholder {
  color: #a7a9ad;
}

.visit-info-card ::v-deep .van-field__button {
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-left: 10px;
}

.companion-field-row ::v-deep .field > .van-cell {
  padding-bottom: 0;
}

.companion-helper {
  margin: 4px 2px 12px;
  color: #8b8e93;
  font-size: 10px;
  line-height: 16px;
  text-align: left;
}

.companion-field-row + .space-field-row {
  display: none;
}

.product-field-row ::v-deep .field > .van-cell {
  padding-bottom: 0;
}

.product-field-row ::v-deep .checkbox .van-cell__value {
  min-height: 0;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
}

.product-field-row ::v-deep .van-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.product-field-row ::v-deep .checkbox-chip .van-checkbox__label {
  font-size: 14px;
}

.key-message-editor,
.key-message-readonly {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid #f0f1f3;
}

.key-message-readonly {
  padding-right: 0;
  padding-left: 0;
}

.key-promotion-popup {
  max-height: 72vh;
  overflow: hidden;
  background: #f6f7f9;
}

.key-promotion-toolbar {
  min-height: 52px;
  padding: 0 16px;
  display: grid;
  grid-template-columns: 64px 1fr 64px;
  align-items: center;
  border-bottom: 1px solid #eceef0;
  background: #fff;
}

.key-promotion-cancel,
.key-promotion-confirm {
  font-size: 14px;
}

.key-promotion-cancel {
  color: #969799;
  text-align: left;
}

.key-promotion-confirm {
  color: #aa341b;
  text-align: right;
}

.key-promotion-title {
  color: #222;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}

.key-promotion-groups {
  max-height: calc(72vh - 52px);
  padding: 10px 12px 18px;
  overflow-y: auto;
}

.key-promotion-group {
  overflow: hidden;
  border: 1px solid #eceef0;
  border-radius: 10px;
  background: #fff;
}

.key-promotion-group + .key-promotion-group {
  margin-top: 10px;
}

.key-promotion-group-heading {
  min-height: 38px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #303236;
  font-size: 14px;
  font-weight: 600;
  background: #faf6f5;
}

.key-promotion-group-count {
  min-width: 20px;
  padding: 1px 6px;
  border-radius: 10px;
  color: #aa341b;
  font-size: 11px;
  font-weight: 500;
  line-height: 17px;
  text-align: center;
  background: #f3e5e2;
}

.key-promotion-popup ::v-deep .key-promotion-option {
  padding: 11px 12px;
}

.key-promotion-popup ::v-deep .key-promotion-option .van-cell__title {
  padding-right: 12px;
  color: #33363a;
  font-size: 14px;
  line-height: 20px;
  text-align: left;
}

.key-promotion-popup ::v-deep .key-promotion-option .van-checkbox {
  margin-bottom: 0;
}

.strategy-map-card {
  padding: 14px;
  overflow: hidden;
  border: 1px solid rgba(31, 35, 40, 0.05);
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 3px 14px rgba(31, 35, 40, 0.045);
}

.strategy-map-title {
  display: flex;
  align-items: center;
  color: #26384a;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;
}

.strategy-map-title-accent {
  width: 5px;
  height: 18px;
  margin-right: 8px;
  border-radius: 4px;
  background: #aa341b;
}

.strategy-map-content ::v-deep .parting-type {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 12px;
}

.strategy-map-content ::v-deep .parting-type-unselected,
.strategy-map-content ::v-deep .parting-type-selected {
  width: auto !important;
  margin: 0 !important;
  border-radius: 8px !important;
}

.strategy-map-content ::v-deep .parting-type-unselected {
  height: 66px !important;
}

.strategy-map-content ::v-deep .parting-type-selected {
  height: 74px !important;
}

.strategy-map-content ::v-deep img[src*="xAxis"] {
  width: 100% !important;
  max-width: 100% !important;
  margin-top: 6px !important;
}

.strategy-map-content ::v-deep .parting-type-action {
  margin-top: 8px;
}

.strategy-map-card--azilect .strategy-map-content ::v-deep .parting-type {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 4px;
}

.strategy-map-card--azilect .strategy-map-content ::v-deep .parting-type-unselected,
.strategy-map-card--azilect .strategy-map-content ::v-deep .parting-type-selected {
  min-width: 0;
  height: 74px !important;
}

.strategy-map-card--azilect .strategy-map-content ::v-deep .parting-type-unselected > div,
.strategy-map-card--azilect .strategy-map-content ::v-deep .parting-type-selected > div {
  width: 100%;
  padding: 7px 4px;
  box-sizing: border-box;
  text-align: center;
}

.strategy-map-card--azilect .strategy-map-content ::v-deep .strategy-stage-label {
  width: auto !important;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  line-height: 1.35;
  text-align: center;
}

.strategy-map-card--azilect .strategy-map-content ::v-deep .strategy-stage-label span {
  display: block;
  white-space: nowrap;
}

::v-deep .van-tab--active {
  color: #aa341b;
}
.question {
  font-size: 14px;
  text-align: left;
}
.space {
  text-align: left;
}
.space > button {
  width: 100px;
}
.space > button ~ button {
  margin-left: 10px;
}

.field-box-style {
  display: block;
  padding: 0;
  &::after {
    display: none;
  }
  &.van-cell--required::before {
    top: 0;
    left: 0;
    line-height: 22px;
  }
  ::v-deep .van-field__label {
    width: 100%;
    margin-bottom: 5px;
    padding-left: 11px;
    color: #202326;
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
  ::v-deep .van-field__value {
    min-height: 34px;
    border: 1px solid #e1e3e6;
    border-radius: 8px;
    padding: 5px 11px;
    display: flex;
    align-items: center;
    background: #fff;

    .van-field__body {
      width: 100%;
    }
  }
}
.tag-container {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.custom-tag {
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  background-color: #ebecf0;
  border-radius: 6px;
  padding: 2px 8px;
  margin-right: 8px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #323233;
  line-height: 1.5;
}
.custom-tag-product {
  flex: none;
  color: #aa341b;
  font-size: 11px;
  font-weight: 600;
}
.custom-tag-product::after {
  margin-left: 5px;
  color: #b5b7ba;
  content: '-';
}
.custom-tag-text {
  min-width: 0;
}
.placeholder-text {
  color: #c8c9cc;
}
</style>
<style>
.fail-toast {
  width: 200px;
}
.save-fail-toast {
  width: 240px;
}
.save-fail-toast .save-error-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.save-fail-toast .save-error-detail {
  margin-top: 5px;
  font-size: 11px;
  line-height: 16px;
  opacity: 0.82;
  text-align: left;
  word-break: break-word;
}
</style>
